import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { BoardProvider } from "@/context/BoardContext";
import { Toaster } from "@/components/ui/sonner";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import SiteLayout from "@/components/site/SiteLayout";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import PatternStudio from "@/pages/PatternStudio";
import Gallery from "@/pages/Gallery";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ServiceAreas from "@/pages/ServiceAreas";
import LocationDetail from "@/pages/LocationDetail";
import CareersHub from "@/pages/CareersHub";
import CareerDetail from "@/pages/CareerDetail";
import Login from "@/pages/Login";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminGallery from "@/pages/admin/AdminGallery";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminProjects from "@/pages/admin/AdminProjects";
import AdminContent from "@/pages/admin/AdminContent";
import AdminVisualizer from "@/pages/admin/AdminVisualizer";
import AdminApplications from "@/pages/admin/AdminApplications";
import AdminJobs from "@/pages/admin/AdminJobs";

import PortalLayout from "@/pages/portal/PortalLayout";
import PortalDashboard from "@/pages/portal/PortalDashboard";
import ProjectDetail from "@/pages/portal/ProjectDetail";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/pattern-studio" element={<PatternStudio />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/service-areas" element={<ServiceAreas />} />
        <Route path="/service-areas/:slug" element={<LocationDetail />} />
        <Route path="/careers" element={<CareersHub />} />
        <Route path="/careers/:slug" element={<CareerDetail />} />
      </Route>

      <Route path="/login" element={<Login />} />

      <Route path="/admin" element={<ProtectedRoute role="admin"><AdminLayout /></ProtectedRoute>}>
        <Route index element={<AdminDashboard />} />
        <Route path="leads" element={<AdminLeads />} />
        <Route path="applications" element={<AdminApplications />} />
        <Route path="jobs" element={<AdminJobs />} />
        <Route path="gallery" element={<AdminGallery />} />
        <Route path="testimonials" element={<AdminTestimonials />} />
        <Route path="projects" element={<AdminProjects />} />
        <Route path="content" element={<AdminContent />} />
        <Route path="visualizer" element={<AdminVisualizer />} />
      </Route>

      <Route path="/portal" element={<ProtectedRoute role="customer"><PortalLayout /></ProtectedRoute>}>
        <Route index element={<PortalDashboard />} />
        <Route path="projects/:id" element={<ProjectDetail />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BoardProvider>
        <BrowserRouter>
          <ScrollToTop />
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </BoardProvider>
    </AuthProvider>
  );
}

export default App;
